











 









const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "mapPromptToJoinOrgToToast_notification",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "activeDomain",
      "storageKey": null
    }
  ],
  "type": "NotifyPromptToJoinOrg",
  "abstractKey": null
};

(node ).hash = "26a30257154de2ed38ed012f01885550";

export default node;
